<template>
    <main class="main-content">
        <page-title id="about-header" :title="$t('about.section1.title')"></page-title>

        <section class="section">
            <div class="columns is-multiline is-mobile has-items-center">
                <div class="column is-full-mobile is-5-tablet has-text-centered mobile-order-2">
                    <img src="/assets/img/veneto-map.png?id=45124741">
                </div>
                <div class="column is-full-mobile is-7-tablet has-text-justified mobile-order-1">
                    <p v-t="'about.section1.paragraphs.1'"></p>
                    <p v-t="'about.section1.paragraphs.2'"></p>
                    <p v-t="'about.section1.paragraphs.3'"></p>
                </div>
            </div>
        </section>

        <parallax-section background="/assets/img/grapes-by-hand.jpg?id=45124741">
            <h2 class="section-title has-text-centered" v-t="'about.section2.title'"></h2>
        </parallax-section>

        <section class="section">
            <div class="columns is-multiline is-mobile has-items-center">
                <div class="column is-full-mobile is-5-tablet has-text-centered mobile-order-2">
                    <img src="/assets/img/alberto-sarah-walking.jpg?id=45124741">
                </div>
                <div class="column is-full-mobile is-7-tablet has-text-justified mobile-order-1">
                    <p v-t="'about.section2.paragraphs.1'"></p>
                    <p v-t="'about.section2.paragraphs.2'"></p>
                    <p v-t="'about.section2.paragraphs.3'"></p>
                </div>
            </div>
        </section>

    </main>
</template>
<script>
    import PageTitle from './../components/PageTitle'
    import ParallaxSection from './../components/ParallaxSection'

    export default {
        components: {
            ParallaxSection,
            PageTitle
        },
        metaInfo() {
            return {
                title: this.$t('seo.about.title'),
                meta: [
                    {name: 'title', content: this.$t('seo.about.title')},
                    {name: 'description', content: this.$t('seo.about.description')}
                ]
            }
        }
    }
</script>